import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { WiseConfig } from "../../../Shared/features/WiseConfig";
import { defaults } from "../shared/defaults";
import menuLink from "../shared/menuLinkWithoutIcons";
import footerTop from "./footerTop";
import newsletterBlock from "./newsLetterForm";
export const collectionSearchUrl = (term)=>`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/catalog/search?qs=${term}`;
const logo = ()=>/*#__PURE__*/ _jsx("img", {
        width: "231",
        height: "83",
        src: "/bkw/images/twente/logo.svg",
        alt: "Bibliotheek Twente",
        "aria-hidden": "true"
    });
const loginUrl = ()=>`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/my-account/checkouts/physical-materials?directLogin=true`;
const searchPlaceholderImage = {
    src: '/bkw/images/twente/logo.svg',
    alt: '',
    width: "322",
    height: "125"
};
const twente = {
    ...defaults,
    logo,
    menuLink,
    footerTop,
    newsletterBlock,
    collectionSearchUrl,
    loginUrl,
    searchPlaceholderImage,
    copy: {
        forms: {
            loadingFailed: 'Het formulier kon helaas niet geladen worden. Herlaad de pagina of neem contact op met Bibliotheek Twente.'
        },
        vacancies: {
            noVacanciesFound: `Helaas, we zoeken op dit moment geen nieuwe collega’s. Houd de website in de gaten voor
        passende vacatures, we zijn regelmatig op zoek naar versterking voor onze bibliotheken!`
        }
    }
};
export default twente;
